(() => {
  'use strict';

  const routes = new Set([
    'home',
    'shop',
    'how-it-works',
    'honey-drops',
    'buzz-bonuses',
    'feature-video',
    'about',
    'faq',
    'contact',
    'customize'
  ]);

  const currentRoute = () => {
    const raw = (window.location.hash || '#home').slice(1).split('?')[0];
    return routes.has(raw) ? raw : 'home';
  };

  const syncHero = (routeName) => {
    const hero = document.querySelector('[data-sassy-centered-hero]');
    if (!hero) return;

    const showHero = routeName === 'home';
    hero.hidden = !showHero;
    hero.setAttribute('aria-hidden', String(!showHero));
  };

  const routeHeading = (routeName) => {
    if (routeName === 'about') {
      return document.querySelector('[data-sh-storybook-about] #sh-story-hero-title')
        || document.querySelector('[data-sh-storybook-about] h1');
    }

    const page = document.querySelector(`#sassyHiveApp .page[data-page="${routeName}"]`);
    return page?.querySelector('.page-hero h1, h1, h2') || page;
  };

  const positionRoute = (smooth = false) => {
    const routeName = currentRoute();
    syncHero(routeName);

    const behavior = smooth && !window.SassyHive?.prefersReducedMotion?.()
      ? 'smooth'
      : 'auto';

    if (routeName === 'home') {
      const raw = (window.location.hash || '#home').slice(1).split('?')[0];
      const anchor = raw !== 'home' ? document.getElementById(raw) : null;
      if (anchor && anchor.closest('#sassyHiveApp .page[data-page="home"]')) {
        const header = document.querySelector('.site-header');
        const headerHeight = Math.ceil(header?.getBoundingClientRect().height || 0);
        const top = Math.max(
          0,
          Math.round(anchor.getBoundingClientRect().top + window.scrollY - headerHeight - 18)
        );
        window.scrollTo({ top, behavior });
        return;
      }
      window.scrollTo({ top: 0, behavior });
      return;
    }

    const target = routeHeading(routeName);
    if (!target) return;

    const header = document.querySelector('.site-header');
    const headerHeight = Math.ceil(header?.getBoundingClientRect().height || 0);
    const top = Math.max(
      0,
      Math.round(target.getBoundingClientRect().top + window.scrollY - headerHeight - 18)
    );

    window.scrollTo({ top, behavior });
  };

  const schedulePosition = (smooth = false) => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => positionRoute(smooth));
    });
  };

  syncHero(currentRoute());

  window.addEventListener('sassy:core-ready', () => schedulePosition(false));
  window.addEventListener('hashchange', () => schedulePosition(true));

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (_) {
      return;
    }

    const routeName = url.hash.slice(1).split('?')[0];
    const sameDocument = url.origin === window.location.origin
      && url.pathname === window.location.pathname;

    if (sameDocument && routes.has(routeName)) {
      window.setTimeout(() => schedulePosition(true), 0);
    }
  });

  window.addEventListener('pageshow', () => schedulePosition(false));
})();
